import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import styled, { css } from 'styled-components';

const ExpansionPanelExtended = withStyles({
  root: {
    width: '100% !important',
    margin: 0,
    borderBottom: '1px solid #EEEEEE',
    padding: '20px 24px 20px 24px',
  },
})(ExpansionPanel);

const FlatExpansionPanel = styled(ExpansionPanelExtended)`
  &:before {
    content: none !important;
  }
`;

const FlatExpansionPanelSummary = withStyles({
  root: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    minHeight: 0,
  },
  content: {
    alignItems: 'center',
    margin: 0,
    '& > :last-child': {
      'padding-right': '0px !important',
    },
  },
  expanded: {
    margin: '0px !important',
    minHeight: '0px !important',
  },
})(ExpansionPanelSummary);

const ExpansionPanelSummaryIconExtended = withStyles({
  root: {
    marginRight: 5,
  },
})(ExpandMoreIcon);

const ExpansionPanelSummaryIcon = styled(ExpansionPanelSummaryIconExtended)`
  transform: rotate(-90deg);
  padding-right: 0px !important;
  transition-duration: 0.2s !important;
  transition-property: transform !important;

  ${props =>
    props.expanded
      ? css`
          transform: rotate(0deg);
        `
      : undefined}
`;

const ExpansionPanelSummaryTitle = styled.p`
  margin: 0px !important;
  flex-grow: 1;
  flex-shrink: 0;
  font-family: Geomanist;
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: -0.4000000059604645px;
  text-align: left;

  ${props =>
    props.expanded
      ? css`
          margin: 0px !important;
        `
      : undefined}
`;

const ExpansionSummaryActionsContainer = styled.div`
  display: flex;
  flex-grow: 0;
  flex-direction: row;
  gap: 8px;
`;

const FlatExpansionPanelDetails = withStyles({
  root: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 0,
  },
})(ExpansionPanelDetails);

const StandardAccordion = ({
  title,
  isExpanded,
  children,
  onChange,
  id,
  renderActions,
}) => {
  return (
    <FlatExpansionPanel
      expanded={isExpanded}
      onChange={(e, expanded) => onChange(id, expanded)}
      elevation={0}
    >
      <FlatExpansionPanelSummary>
        <ExpansionPanelSummaryIcon expanded={isExpanded ? 'true' : undefined} />
        <ExpansionPanelSummaryTitle
          expanded={isExpanded}
          style={{ margin: 0, flexShrink: 0 }}
        >
          {title}
        </ExpansionPanelSummaryTitle>
        <ExpansionSummaryActionsContainer>
          {renderActions ? renderActions() : null}
        </ExpansionSummaryActionsContainer>
      </FlatExpansionPanelSummary>

      <FlatExpansionPanelDetails>{children}</FlatExpansionPanelDetails>
    </FlatExpansionPanel>
  );
};

export default StandardAccordion;



// WEBPACK FOOTER //
// ./src/components/Utility/StandardAccordion/index.jsx